<template>
  <div>
    <nav-bar></nav-bar>
    <loading-bar></loading-bar>
    <router-view></router-view>
  </div>
</template>

<style scoped>
</style>

<script>
import NavBar from './NavBar'
import LoadingBar from './LoadingBar'

export default {
  components: {
    NavBar,
    LoadingBar
  }
}
</script>



// WEBPACK FOOTER //
// Soc.vue?190b8ab0